import { render } from "./videoWechat.vue?vue&type=template&id=32a07397&scoped=true"
import script from "./videoWechat.vue?vue&type=script&lang=js"
export * from "./videoWechat.vue?vue&type=script&lang=js"

import "./videoWechat.vue?vue&type=style&index=0&id=32a07397&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a07397"]])

export default __exports__